// extracted by mini-css-extract-plugin
var _1 = "webpack-components-core-Avatar-Avatar-module__Avatar";
var _2 = "webpack-components-core-Avatar-Avatar-module__green";
var _3 = "webpack-components-core-Avatar-Avatar-module__grey";
var _4 = "webpack-components-core-Avatar-Avatar-module__lg";
var _5 = "webpack-components-core-Avatar-Avatar-module__md";
var _6 = "webpack-components-core-Avatar-Avatar-module__navy";
var _7 = "webpack-components-core-Avatar-Avatar-module__sm";
var _8 = "webpack-components-core-Avatar-Avatar-module__teal";
var _9 = "webpack-components-core-Avatar-Avatar-module__xl";
var _a = "webpack-components-core-Avatar-Avatar-module__xs";
var _b = "webpack-components-core-Avatar-Avatar-module__yellow";
export { _1 as "Avatar", _2 as "green", _3 as "grey", _4 as "lg", _5 as "md", _6 as "navy", _7 as "sm", _8 as "teal", _9 as "xl", _a as "xs", _b as "yellow" }
